import Vue from 'vue';

// Simple reactive modal manager (Vue 2)
// Replaces the Vuex `modal` module. Use the exported methods to open/close/trigger.

const state = Vue.observable({
  confirmation: {
    open: false,
    title: null,
    content: null,
    trigger: () => {}
  }
});

function openConfirmation({ title = null, content = null, trigger = () => {} } = {}) {
  state.confirmation.title = title;
  state.confirmation.content = content;
  state.confirmation.trigger = trigger;
  state.confirmation.open = true;
}

function closeConfirmation() {
  state.confirmation.title = null;
  state.confirmation.content = null;
  state.confirmation.trigger = () => {};
  state.confirmation.open = false;
}

function triggerConfirmation() {
  try {
    state.confirmation.trigger();
  } catch (err) {
    // swallowing errors from triggered callback; caller should handle errors inside trigger
    // to avoid uncaught exceptions here
    // console.error(err);
  }
  closeConfirmation();
}

export default {
  state,
  openConfirmation,
  closeConfirmation,
  triggerConfirmation,
};
